export default function byteSizeToDescription(byteSize: number): string {
    if (byteSize < 0) throw new Error(`byteSize = ${byteSize}. Can't have a byteSize less than 0`);
    if (byteSize === 0) return '0B';
    const sizeDivisor = Math.floor(Math.log(byteSize) / Math.log(1000));
    const decimalPlaces = sizeDivisor > 2 ? 1 : 0;
    const units = ['B', 'KB', 'MB', 'GB', 'TB'];
    const unit = units[sizeDivisor];
    if (unit === undefined)
        throw new Error(
            `Size Divisor '${sizeDivisor}' was outside the expected range of 0-${units.length} caused by a byteSize of '${byteSize}'`,
        );
    const sizeValue = (byteSize / 1000 ** sizeDivisor).toFixed(decimalPlaces);
    const text = `${sizeValue} ${unit}`;
    return text;
}
